





















import { Component, Vue } from 'vue-property-decorator'
import { membershipState } from '../../store/modules/MembershipState'
import { ssoLogin } from '../../modules/util/SapUtil'
import LoadingAnimationWithoutBg from '../../components/Parts/LoadingAnimationWithoutBg.vue'

@Component({
  components: { LoadingAnimationWithoutBg }
})
export default class Loginicon extends Vue {
  // -------------------------------------------------------------------------------------------------------------------
  // hocks

  private mounted() {
    // 野良ログインボタンにイベントを追加
    const elements = document.querySelectorAll('.js-memberLoginButton')
    elements.forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault()

        this.signin()
      })
    })
  }

  // ---------------------------------------------------------------------------
  // computed
  get isLogin(): boolean {
    return membershipState.isLogin
  }

  /**
   * ログイン判定処理 状態フラグ
   * @true ログイン判定中
   * @false ログイン判定完了
   */
  get isLoadingLogin(): boolean {
    return membershipState.isLoadingLogin
  }

  // ---------------------------------------------------------------------------
  // methods
  private signin() {
    membershipState.addIsLoadingLogin(true)
    ssoLogin(window.location.href, 'gigya-login-screen')
  }
}
